<template>
	<div>
		<v-card class="flex pl-8 pr-8 pt-5 pb-15" color="#e0e0e0" v-if="JSON.stringify(empresa) != '{}'">
			<v-row>
				<v-col>
					<v-card-title class="pa-0">
						<strong class="subheading">{{ this.empresa.nomefantasia }}</strong>
					</v-card-title>
					<v-card-subtitle class="pl-0 pb-0 pt-3"> {{ this.empresa.nomerazao }} </v-card-subtitle>
					<v-card-text class="pa-0">
						<v-row>
							<v-col class="pa-0">
								<v-btn text @click="abrirLocalizacao()" v-if="empresa.cidade">
									<v-icon color="black"> mdi-map-marker-outline </v-icon>
									{{ this.empresa.cidade }} - {{ this.empresa.uf }}
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pa-0">
								<v-btn text @click="chamarWhatsapp()" v-if="empresa.whatsapp">
									<v-icon color="black"> mdi-whatsapp </v-icon>
									{{ formatarTelefone(empresa.whatsapp) }} 
								</v-btn>
								<v-btn text @click="tel()" v-if="empresa.telefone">
									<v-icon color="black"> mdi-phone-outline </v-icon>
									{{ formatarTelefone(empresa.telefone) }}
								</v-btn>
							</v-col>
						</v-row>
						<v-spacer></v-spacer>
					</v-card-text>
				</v-col>
			</v-row>
		</v-card>
		<v-footer  padless app >
			<div class="footer">
				<img class="footer__image" src="https://sicecommerce.s3.dualstack.us-east-1.amazonaws.com/logo-sic-store-02.PNG"/>
				<div  v-if="JSON.stringify(empresa) != '{}'" class="footer__text">
						<!-- {{ getAno }} — <strong>{{ this.catalogo.nome }}</strong> (expiração em: {{ convertDate(this.catalogo.dt_expiracao) }}) -->
				</div>
				<div v-else class="footer__text">{{ getAno }} — <strong>SÉCULOS SISTEMAS</strong></div>
				<div class="footer__text">
					<div class="footer__text--powered-by">desenvolvido por</div>
					<img class="footer__image" src="https://sicecommerce.s3.dualstack.us-east-1.amazonaws.com/Logos%20SIC%20Sistemas%20-%20preto.png"/>
				</div>
			</div>
		</v-footer>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import montaMensagemContato from '../../mixins/methods/montaMensagemContato'

export default {
	computed: {
		...mapGetters({ empresa: 'empresa', catalogo: 'catalogo' }),
		getAno() {
			return new Date().getFullYear()
		},
	},
	methods: {
		chamarWhatsapp() {
			const url = montaMensagemContato(this.empresa.whatsapp, this.empresa.mensagemWpp)
			window.location.replace(url)
		},
		abrirLocalizacao() {
			if (this.empresa.localizacao) window.open(this.empresa.localizacao)
		},
		tel() {
			if (this.empresa.telefone) window.location.href = `tel:${this.empresa.telefone}`
		},
		formatarTelefone(telefone) {
			let telefoneFormatado = telefone
						.replaceAll(' ', '')
						.replaceAll('(', '')
						.replaceAll(')', '')
						.replaceAll('-', '')

			if(telefoneFormatado.length == 10)
				return `(${telefoneFormatado.substring(0, 2)}) ${telefoneFormatado.substring(2, 3)}${telefoneFormatado.substring(3, 6)}-${telefoneFormatado.substring(6, 10)}`
			else
				return `(${telefoneFormatado.substring(0, 2)}) ${telefoneFormatado.substring(2, 3)} ${telefoneFormatado.substring(3, 7)}-${telefoneFormatado.substring(7, 11)}`
		},
	},
}
</script>

<style>
.footer{
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	background-color: #e0e0e0;
	border-top: 1px solid #bdbdbd;
	height: 60px;
	padding: 1rem 2rem;
}

.footer__image {
	height: 100%;
}

.footer__text {
	font-size: 14px;
	height: 100%;
	display: flex;
	gap: 0.5rem;
	align-items: center;
}

.footer__text--powered-by {
	align-items: center;
	font-weight: bold;
	font-style: italic;
	font-size: 12px;
}

@media only screen and (max-width: 630px) {
	.footer{
		gap: 0.5rem;
	}
	.footer__text {
		text-align: center;
		font-size: 11px;
	}

}

</style>
